import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  let request = req;
  const token = auth.accessToken;
  const demoRole = auth.selectedDemoRole;

  if (token && isApiRequest(req.url)) {
    // FormData: do not send application/json Content-Type; the browser sets multipart boundaries.
    let headers = req.body instanceof FormData ? req.headers.delete('Content-Type') : req.headers;
    headers = headers.set('Authorization', `Bearer ${token}`);
    if (demoRole) {
      headers = headers.set('X-IdeasHub-Demo-Role', demoRole);
    }
    request = req.clone({ headers });
  }

  return next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && isApiRequest(req.url)) {
        auth.logout(false);
        void router.navigate(['/login']);
      }

      return throwError(() => error);
    })
  );
};

function isApiRequest(url: string): boolean {
  const parsedUrl = new URL(url, window.location.origin);
  return parsedUrl.pathname.startsWith('/api/');
}
